export default __webpack_public_path__ + "7f5e5344551f5b92036bbd983be8387c.svg";